import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { EnumValidValueItemModel } from 'src/app/models/enum/enum-valid-value-item.model';
import { AnesthesiaConfigurationModel } from 'src/app/modules/treatment/models/configuration/anesthesia-configuration.model';
import { AnesthesiaEndoExplosionConfigurationModel } from 'src/app/modules/treatment/models/configuration/anesthesia-endo-explosion-configuration.model';
import { TreatmentEndoAnesthesiaDataModel } from 'src/app/modules/treatment/models/treatment-endo-anesthesia-data.model';
import { AnesthesiaService } from 'src/app/services/anesthesia.service';
import { DialogService } from 'src/app/services/dialog.service';
import { StaticDataService } from 'src/app/services/static-data.service';
import { TdoTableV2Component } from 'src/app/tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { ConfigurationService } from '../../configuration.service';
import { TdoTableSelectionEvent } from 'src/app/tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { AnesthesiaEndoExplosionItemConfigurationModel } from 'src/app/modules/treatment/models/configuration/anesthesia-endo-explosion-item-configuration.model';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-anesthesia-explosion-config',
  templateUrl: './anesthesia-explosion-config.component.html',
  styleUrls: ['./anesthesia-explosion-config.component.scss']
})
export class AnesthesiaExplosionConfigComponent implements AfterViewInit, OnInit {
  @ViewChild('expTable') expTable: TdoTableV2Component;
  @ViewChild('btnAddExplosionItem') btnAddExplosionItem: MatButton;
  @ViewChild('explosionConfigTable') explosionConfigTable: TdoTableV2Component;

  anesthesia: TreatmentEndoAnesthesiaDataModel[];
  anesthesiaConfigurationModel: AnesthesiaConfigurationModel;

  selectedExplosionModel: AnesthesiaEndoExplosionConfigurationModel;

  anesthesiaQuantityEnums: EnumValidValueItemModel[];
  anesthesiaTypeEnums: EnumValidValueItemModel[];
  anesthesiaAdministeredEnums: EnumValidValueItemModel[];

  selectedRow: TreatmentEndoAnesthesiaDataModel;
  explosionList: AnesthesiaEndoExplosionConfigurationModel[] = [];
  isLoading: boolean = true;

  constructor(
    private cd: ChangeDetectorRef,
    private staticDataService: StaticDataService,
    private anesthesiaService: AnesthesiaService,
    public configurationService: ConfigurationService,
    private dialogService: DialogService) {
  }

  ngOnInit(): void {

    this.anesthesiaService.getAnesthesiaConfigurationModels().subscribe((configRes) => {

      this.anesthesiaConfigurationModel = configRes;

      this.explosionList = this.anesthesiaConfigurationModel.explosionConfigs;

      this.selectedExplosionModel = this.explosionList[0];

      this.refreshExplosionTableViewData();

    });
  }

  ngAfterViewInit(): void {
    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.loadEnums();
          this.isLoading = false;
        }
      });
    } else {
      this.loadEnums();
      this.isLoading = false;
    }
  }

  loadEnums() {
    this.anesthesiaQuantityEnums = this.staticDataService.getValidValueItemsByValidValueName('enumAnestQuantity');
    this.anesthesiaTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumAnestType');
    this.anesthesiaAdministeredEnums = this.staticDataService.getValidValueItemsByValidValueName('enumAnestAnesthesias');

  }

  onNewExplosion() {
    const model = new AnesthesiaEndoExplosionConfigurationModel();
    model.Name = "# New Explosion";
    model.cfgAnesthesiaEndoExplosionItems = [];

    this.explosionList.unshift(model);

    this.selectedExplosionModel = model;

    this.refreshExplosionTableViewData();
    this.refreshExplosionItemTableViewData();

  }

  onNewExplosionItem() {

    const model = new AnesthesiaEndoExplosionItemConfigurationModel();
    model.AnesthesiaEndoExplosionID = this.selectedExplosionModel.AnesthesiaEndoExplosionID;

    this.selectedExplosionModel.cfgAnesthesiaEndoExplosionItems.push(model);
    this.refreshExplosionItemTableViewData();

  }

  onExplosionSelected(event: TdoTableSelectionEvent) {
    if (event.row.model)
      this.selectedExplosionModel = event.row.model as AnesthesiaEndoExplosionConfigurationModel;
    else if (event.model)
      this.selectedExplosionModel = event.model as AnesthesiaEndoExplosionConfigurationModel;
    this.refreshExplosionItemTableViewData();
  }


  refreshExplosionTableViewData() {

    const ivl = setInterval(() => {
      if (!this.expTable) {
        return;
      }
      clearInterval(ivl);

      this.expTable.updateData();
    }, 100);
  }

  refreshExplosionItemTableViewData() {

    const ivl = setInterval(() => {
      if (!this.explosionConfigTable) {
        return;
      }
      clearInterval(ivl);
      this.explosionConfigTable.updateData();
    }, 100);
  }

  onDeleteExplosion(model: AnesthesiaEndoExplosionConfigurationModel) {

    this.dialogService.openConfirmDialog('Are you sure you want to delete this item?').subscribe((res1) => {
      if (res1) {
        this.anesthesiaService.deleteAnesthesiaExplosionConfiguration(model).subscribe(res => {
          const idx = this.explosionList.findIndex(p => p.AnesthesiaEndoExplosionID === model.AnesthesiaEndoExplosionID);
          if (idx > -1) {
            this.explosionList.splice(idx, 1);
            this.refreshExplosionTableViewData();
          }
        });
      }
    });

  }

  onDeleteExplosionItem(model: AnesthesiaEndoExplosionItemConfigurationModel) {

    this.dialogService.openConfirmDialog('Are you sure you want to delete this item?').subscribe((res1) => {
      if (res1) {
        const idx = this.selectedExplosionModel.cfgAnesthesiaEndoExplosionItems.findIndex(p => p.AnesthesiaEndoExplosionItemID === model.AnesthesiaEndoExplosionItemID);
        if (idx > -1) {
          this.selectedExplosionModel.cfgAnesthesiaEndoExplosionItems.splice(idx, 1);
          this.refreshExplosionItemTableViewData();
          this.configurationService.setDirty();
        }
      }
    });

  }

  saveAnesthesiaExplosion() {
    this.isLoading = true;
    this.explosionList.forEach((item, index) => {
      this.saveAnesthesiaExplosionItem(item, index);
    });
    this.refreshExplosionTableViewData();
    this.refreshExplosionItemTableViewData();
    this.configurationService.setClean();
    this.isLoading = false;
  }

  saveAnesthesiaExplosionItem(item: AnesthesiaEndoExplosionConfigurationModel, index: number) {

    console.log("saveAnesthesiaExplosionItem", item);
    this.anesthesiaService.saveAnesthesiaExplosionConfigurationItem(item)
      .subscribe((ret) => {
        this.explosionList[index] = ret;
      });


  }
}
